import React from 'react';

function sanitizeWorkspaceTestId(workspaceKey) {
  return String(workspaceKey || 'workspace')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || 'workspace';
}

export default function WorkspaceSwitcher({
  workspaces = [],
  activeWorkspace = null,
  onSelect,
}) {
  const visibleWorkspaces = Array.isArray(workspaces) ? workspaces.filter(Boolean) : [];

  if (visibleWorkspaces.length <= 1) {
    return null;
  }

  return (
    <div
      data-testid="workspace-switcher"
      aria-label="Workspace switcher"
      style={{
        display: 'inline-flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '6px',
        padding: '4px',
        borderRadius: '999px',
        border: '1px solid var(--border-subtle)',
        background: 'var(--bg-elevated)',
      }}
    >
      {visibleWorkspaces.map((workspace) => {
        const isActive = activeWorkspace?.key === workspace.key;

        return (
          <button
            key={workspace.key}
            type="button"
            data-testid={`workspace-option-${sanitizeWorkspaceTestId(workspace.key)}`}
            onClick={() => onSelect?.(workspace)}
            aria-pressed={isActive}
            className="app-page-chip"
            style={{
              border: 'none',
              cursor: 'pointer',
              fontWeight: 600,
              color: isActive ? 'var(--text-primary)' : 'var(--text-secondary)',
              background: isActive ? 'var(--workspace-chip-active-bg)' : 'var(--workspace-chip-bg)',
            }}
          >
            {workspace.label}
          </button>
        );
      })}
    </div>
  );
}
